import { Button, Link, Notice, Table, Text } from "@smooth/design-system-components"
import NextLink from "next/link"
import { useRouter } from "next/router"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import useSWR from "swr"
import { CONTRACT_FLAG_CONFIGS, type ContractFlagKind, type ContractFlagListItem } from "../kinds"
import Pagination from "src/components/tailwind-components/Pagination"
import { formatDateTime } from "src/features/admin/screen-shared"

const COLUMNS = [
  { key: "id", header: "Id" },
  { key: "contract", header: "Contract" },
  { key: "createdAt", header: "Created At" },
]

/** 請求停止・遅延ページで非表示の一覧。admin と同じ列を ID の新しい順に出し、一括作成へ進める */
export const ContractFlagList = ({ kind, page }: { kind: ContractFlagKind; page: number }) => {
  const config = CONTRACT_FLAG_CONFIGS[kind]
  const router = useRouter()
  const { getWithToken } = useSmoothApi()
  const { data, error, isLoading } = useSWR(
    `${config.endpoint}?page=${page}`,
    async (url: string) => (await getWithToken(url)).data as Record<string, unknown>,
    { revalidateOnFocus: false }
  )

  if (error) return <Notice tone="error">一覧を取得できませんでした</Notice>
  if (isLoading || !data) return <Text>読み込み中...</Text>

  const records = data[config.listKey] as ContractFlagListItem[]
  const pagination = data.pagination as { totalPages: number; totalCount: number }
  const rows = records.map((record) => ({
    id:
      record.id === null ? null : <Link href={`${config.basePath}/${record.id}`}>{record.id}</Link>,
    contract:
      record.contractId === null ? null : (
        <Link href={`/admin/contracts/${record.contractId}`}>{record.contractId}</Link>
      ),
    createdAt: formatDateTime(record.createdAt),
  }))

  return (
    <div className="flex flex-col gap-4">
      <div>
        <Button asChild>
          <NextLink href={`${config.basePath}/bulk-new`}>{config.bulkLinkLabel}</NextLink>
        </Button>
      </div>
      <Table
        columns={COLUMNS}
        rows={rows}
        onRowClick={(index) => router.push(`${config.basePath}/${records[index].id}`)}
      />
      <Pagination
        pagination={{
          currentPage: page,
          totalPages: pagination.totalPages,
          totalCount: pagination.totalCount,
        }}
        onPageChange={(next) => router.push({ query: { ...router.query, page: next } })}
      />
    </div>
  )
}
